import React from 'react';
import styled from 'styled-components';
import { Typo } from 'tmt-ui-kit';
import PropTypes from 'prop-types';

const Title = styled(Typo.HeaderThree)`
  font-size: 18px !important;
  color: ${props => props.theme.orange} !important;
  margin: 0;
  margin-bottom: 8px;
`;

const MenuText = styled(Typo.Paragraph)`
  font-size: 16px !important;
`;

const Menus = props => {
  const { menus } = props;
  return (
    <div>
      <Title>Menu</Title>
      <ul>
        {menus.map(menu => (
          <li><MenuText>{menu}</MenuText></li>
        ))}
      </ul>
    </div>
  );
};

Menus.propTypes = {
  menus: PropTypes.array
};

export default Menus;
